import React from 'react'
import styled from 'styled-components'
import { SchoolDetails } from '../SchoolDetails'
import { PageCarouselView } from '../../components/PageCarouselView'
import { SchoolProp } from '../props/SchoolProp'

const StyledSchoolPageCarouselView = styled(PageCarouselView)`
  min-height: 80vh;
`

interface ISchoolPageCarouselViewProps {
  schools: Array<SchoolProp>
  slideIndex: number
  onSlideChange: (slideIndex: number) => void
}

const SchoolPageCarouselView: React.FC<ISchoolPageCarouselViewProps> = ({
  schools,
  slideIndex,
  onSlideChange,
}) => (
  <StyledSchoolPageCarouselView
    slideIndex={slideIndex}
    onSlideChange={onSlideChange}
    items={schools}
    element={<SchoolDetails />}
  />
)

export { SchoolPageCarouselView }
